import { render, staticRenderFns } from "./edit-business-form.vue?vue&type=template&id=0f9960a8&scoped=true&"
import script from "./edit-business-form.vue?vue&type=script&lang=js&"
export * from "./edit-business-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9960a8",
  null
  
)

export default component.exports